import React from 'react';
import LanguageToggle from './LanguageToggle';
import { useLanguage } from '../i18n/LanguageContext';
import { trackBookingClick } from '../lib/tracking';

export default function Header() {
  const { t } = useLanguage();

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between gap-3">
        <a href="https://medispa.hr/" className="flex items-center shrink-0">
          <img
            src="https://static.lumi.new/material/20/208703255e0d63a48f5f163232864f58.png"
            alt="MediSpa Skin & Laser Clinic"
            className="h-10 sm:h-12 md:h-16 w-auto object-contain"></img>

        </a>
        <div className="flex items-center gap-2 sm:gap-4">
          <LanguageToggle />
          <div className="button-wrapper">
            <a
              href="https://medispahr.wixforms.com/f/7479898417246766083"
              target="_blank"
              rel="noopener noreferrer"
              data-cta="book_now"
              data-cta-location="header"
              onClick={() => trackBookingClick('header')}
              className="guten-button guten-button-sm inline-block px-4 sm:px-6 py-3 bg-[#768064] text-white text-sm md:text-base font-medium rounded transition-colors duration-300 hover:bg-[#5d6950] whitespace-nowrap">

              <span>{t.common.bookAppointment}</span>
            </a>
          </div>
        </div>
      </div>
    </header>);

}
